import arrayFrom from 'array-from';

function addClass(element, className) {
  if (!element) {
    return;
  }

  if (
    Object.prototype.toString.call(element) === '[object NodeList]' ||
    Object.prototype.toString.call(element) === '[object Array]' ||
    Object.prototype.toString.call(element) === '[object HTMLCollection]'
  ) {
    arrayFrom(element).forEach(subelement => addClass(subelement, className));
    return;
  }

  const classes = (element.getAttribute('class') || '').split(' ').filter(Boolean).filter(cn => cn !== className);
  classes.push(className);
  element.setAttribute('class', classes.join(' '));
}

function removeClass(element, className) {
  if (!element) {
    return;
  }

  if (
    Object.prototype.toString.call(element) === '[object NodeList]' ||
    Object.prototype.toString.call(element) === '[object Array]' ||
    Object.prototype.toString.call(element) === '[object HTMLCollection]'
  ) {
    arrayFrom(element).forEach(subelement => removeClass(subelement, className));
    return;
  }

  const classes = (element.getAttribute('class') || '').split(' ').filter(Boolean).filter(cn => cn !== className);
  element.setAttribute('class', classes.join(' '));
}

function hasClass(element, className) {
  if (!element) {
    return false;
  }
  return (element.getAttribute('class') || '').split(' ').some(cn => cn === className);
}

function toggleClass(element, className) {
  if (!element) {
    return;
  }
  if (hasClass(element, className)) {
    removeClass(element, className);
  } else {
    addClass(element, className);
  }
}

function getParents(node) {
  const nodeParents = [];
  let iterateNode = node;
  while (iterateNode && iterateNode !== document) {
    nodeParents.push(iterateNode);
    iterateNode = iterateNode.parentNode || iterateNode.parentElement;
  }
  return nodeParents;
}

function isNumber(number) {
  return !isNaN(number - 0) && number !== null && number !== '' && number !== false;
}

function findParent(element, selector) {
  let parentElement = element.parentElement;

  if (parentElement !== null) {
    if (!parentElement.classList.contains(selector)) {
      parentElement = findParent(parentElement, selector);
    }
  }

  return parentElement;
}

function getWindowSize() {
  /* === grab the correct inner size without scrollbar - var innerWidth = zo.innerSize().width; === */
  let v = window;
  let a = 'inner';

  if (!('innerWidth' in v)) {
    a = 'client';
    v = document.documentElement || document.body;
  }

  return {
    width: v[`${a}Width`],
    height: v[`${a}Height`],
  };
}

export {
  addClass,
  hasClass,
  isNumber,
  findParent,
  getParents,
  removeClass,
  toggleClass,
  getWindowSize,
};



// WEBPACK FOOTER //
// ./src/javascript/tools/helpers.js